"use strict";

const globals = {};

export function ShippingLocationEditorFactory(
  $q,
  $cart,
  ShippingLocationPicker,
  ShippingLocationPrompt
) {
  "ngInject";
  class ShippingLocationEditor {
    constructor() {
      var me = this;
      me.picker = new ShippingLocationPicker();
      me.prompt = new ShippingLocationPrompt();
      //promises
      [
        "creating",
        "created",
        "editing",
        "edited",
        "selecting",
        "selected",
        "deleting",
        "deleted",
      ].forEach((k) => {
        me[k] = $q.defer();
        me[k].on =
          me[k].subscribe =
          me[k].sub =
            (cb) => me[k].promise.finally(null, cb);
      });
    }
    edit(shippingLocation) {
      if (!shippingLocation) shippingLocation = $cart.shippingLocation;
      console.warn("edit(shippingLocation", shippingLocation);
      let picker = this.picker;
      let prompt = this.prompt;
      picker.criteria.search = "";
      picker.load(true).then((_args) => {
        if (picker.total) {
          picker.open({ current: shippingLocation }).catch((args) => {
            if (args.reason === "create") {
              prompt.open({ title: "Create a new shipping location..." });
            } else if (args.reason === "dropship") {
              $cart.shippingLocation.dropShip = true;
              $cart.shippingLocation.id = "DROPSHIP";
              prompt.open({
                title: "Enter drop ship location...",
                request: $cart.shippingLocation,
              });
            } else if (args.reason === "edit") {
              prompt.open({
                title: "Modify shipping location...",
                request: args.shippingLocation,
              });
            }
          });
        } else {
          console.debug("BL*** got no results");
          shippingLocation.id = "";
          prompt.open({
            title: "Create a new shipping location",
            request: shippingLocation,
          });
        }
      });
    }
  }
  return ShippingLocationEditor;
}

export function ShippingLocationEditorDirectiveFactory(
  $parse,
  ShippingLocationEditor
) {
  return {
    restrict: "EA",
    scope: false,
    link(scope, element, attr) {
      var editor = new ShippingLocationEditor();
      attr.onSelected &&
        me.picker.selected.subscribe((args) =>
          $parse(attr.onSelected)(scope, args)
        );
      attr.onEdited &&
        me.prompt.edited.subscribe((args) =>
          $parse(attr.onEdited)(scope, args)
        );
      attr.onCreated &&
        me.prompt.created.subscribe((args) =>
          $parse(attr.onCreated)(scope, args)
        );
      attr.onDeleted &&
        me.picker.deleted.subscribe((args) =>
          $parse(attr.onDeleted)(scope, args)
        );
      attr.ngModel && $parse(attr.ngModel).assign(scope, editor);

      var $targets = attr.clickSelector
        ? element.find(attr.clickSelector)
        : element;
      $targets.on("click", (_e) => {
        editor.edit(scope.$eval(attr.shippingLocation));
      });
    },
  };
}
